'use es6';

import CollectionListing from 'ecosystem-marketplace-core/records/CollectionListing';
import * as StorefrontCollection from '../constants/StorefrontCollection';
export const getIsLegacyCollectionListing = collectionListing => {
  if (!(collectionListing instanceof CollectionListing)) {
    throw new Error(`Expected CollectionListing instance. Received ${typeof collectionListing}.`);
  }

  const {
    collectionId
  } = collectionListing;
  return Object.values(StorefrontCollection).includes(collectionId);
};